import { FaReact, FaNode, FaCss3Alt } from 'react-icons/fa';
import { SiJavascript, SiDart, SiFlutter, SiAngular } from 'react-icons/si';
import { BiLogoMongodb } from 'react-icons/bi';

import DrHeroImg from '../assets/projects/drhero-project.png';
import XiaFitImg from '../assets/projects/xiafit-project.png';
import PahImg from '../assets/projects/pah-project.png';
import SyrexImg from '../assets/projects/syrex-project.png';
import PetImg from '../assets/projects/pet-project.png';
import HlbImg from '../assets/projects/hlb-project.png';
import LyntellImg from '../assets/projects/lyntell-project.png';
import BilleezImg from '../assets/projects/billeez-project.png';

// Placeholder for projects without images yet.
const PLACEHOLDER = null;

export const Skills = [
  {
    id: 0,
    tech: 'Flutter',
    icon: <SiFlutter />,
    color: '#02569B',
  },
  {
    id: 1,
    tech: 'Dart',
    icon: <SiDart />,
    color: '#0175C2',
  },
  {
    id: 2,
    tech: 'React JS',
    icon: <FaReact />,
    color: '#61DAFB',
  },
  {
    id: 3,
    tech: 'JavaScript',
    icon: <SiJavascript />,
    color: '#F7DF1E',
  },
  {
    id: 4,
    tech: 'Node JS',
    icon: <FaNode />,
    color: '#339933',
  },
  {
    id: 5,
    tech: 'MongoDB',
    icon: <BiLogoMongodb />,
    color: '#47A248',
  },
  {
    id: 6,
    tech: 'Angular',
    icon: <SiAngular />,
    color: '#DD0031',
  },
  {
    id: 7,
    tech: 'CSS',
    icon: <FaCss3Alt />,
    color: '#1572B6',
  },
];

export const projectDetails = [
  {
    id: 0,
    project_name: 'HLB Fitness',
    project_desc:
      'A global fitness platform offering expert-led virtual training, personalized workout programs, yoga sessions, diet plans, appointment booking with trainers, and live & on-demand sessions.',
    tech_stack: ['Flutter', 'Firebase', 'Video Streaming', 'Chat'],
    project_img: HlbImg,
    project_url: 'https://apps.apple.com/us/app/hlb-fitness/id6744553337',
  },
  {
    id: 1,
    project_name: 'Lyntell',
    project_desc:
      'A comprehensive construction management platform with task management, finance tracking, stock management, document storage, and role-based user management for contractors and project managers.',
    tech_stack: ['Flutter', 'Firebase', 'REST API', 'Cloud Storage'],
    project_img: LyntellImg,
    project_url: 'https://apps.apple.com/us/app/lyntell/id6744964241',
  },
  {
    id: 2,
    project_name: 'Syrex Khiladee',
    project_desc:
      'Service engineer management app enabling efficient customer complaint tracking, outlet management, and detailed product information access for streamlined service operations.',
    tech_stack: ['Flutter', 'Firebase', 'REST API'],
    project_img: SyrexImg,
    project_url: 'https://apps.apple.com/us/app/syrex-khilladee/id6741659760',
  },
  {
    id: 3,
    project_name: 'Petologist',
    project_desc:
      'Pet care application for parents featuring medical history tracking, doctor booking, appointment management, and video calling with veterinarians.',
    tech_stack: ['Flutter', 'Firebase', 'Video Call', 'REST API'],
    project_img: PetImg,
    project_url: 'https://play.google.com/store/apps/details?id=com.petologist.parentapp',
  },
  {
    id: 4,
    project_name: 'Dr Hero',
    project_desc:
      'Healthcare platform for remote medical consultations, enabling users to access medical information, schedule appointments, and receive personalized health recommendations with Webview video call and Stripe payment gateway.',
    tech_stack: ['Flutter', 'AWS', 'Riverpod', 'Stripe'],
    project_img: DrHeroImg,
    project_url: 'https://www.drhero.ae',
  },
  {
    id: 5,
    project_name: 'Billeez POS',
    project_desc:
      'Mobile POS application with billing, editable bill history, tax/VAT management, and tools for customer, staff, and inventory management including bulk inventory uploads and real-time stock updates. Integrated purchase and expense management for seamless supplier transactions.',
    tech_stack: ['Flutter', 'Firebase', 'REST API'],
    project_img: BilleezImg,
    project_url: 'https://play.google.com/store/apps/details?id=com.cypersystems.billeez',
  },
  {
    id: 6,
    project_name: 'XiaFit',
    project_desc:
      'Personalized health and fitness app with coach interaction. Features include personalized diet plans, workout sessions, real-time chat with coaches, and video workout tutorials for proper exercise techniques.',
    tech_stack: ['Flutter', 'Riverpod', 'Firebase', 'Socket Chat'],
    project_img: XiaFitImg,
    project_url: 'https://www.xiafit.com',
  },
  {
    id: 7,
    project_name: 'PAH Mobile App',
    project_desc:
      'Compliance management application designed for chartered accounting clients, offering a streamlined way to manage and access important financial records and documents.',
    tech_stack: ['Flutter', 'Firebase', 'REST API'],
    project_img: PahImg,
    project_url: 'https://play.google.com/store/apps/details?id=com.cypersystems.pahapp',
  },
  {
    id: 8,
    project_name: 'CirclDot',
    project_desc:
      'Digital business card solution allowing users to instantly share contact info, social media profiles, files, and videos with just a tap or scan, streamlining the networking process.',
    tech_stack: ['Flutter', 'NFC', 'QR Scanner'],
    project_img: PLACEHOLDER,
    project_url: '#',
  },
  {
    id: 9,
    project_name: 'CaseTracker',
    project_desc:
      'Incident recording and tracking application utilizing NFC technology to facilitate recording and tracking of various events and incidents. Reduces manual data entry errors with GPS location services.',
    tech_stack: ['Flutter', 'NFC', 'GPS'],
    project_img: PLACEHOLDER,
    project_url: '#',
  },
  {
    id: 10,
    project_name: 'LetsContact',
    project_desc:
      'NFC-based contact sharing application leveraging NFC to streamline digitizing and sharing business or profile cards with QR & barcode scanning and GPS location services.',
    tech_stack: ['Flutter', 'NFC', 'QR Scanner', 'GPS'],
    project_img: PLACEHOLDER,
    project_url: 'https://www.letscontact.digital',
  },
];

export const navLinks = [
  {
    id: 0,
    name: 'Home',
    href: 'Home',
  },
  {
    id: 1,
    name: 'My Skills',
    href: 'Skills',
  },
  {
    id: 2,
    name: 'My Projects',
    href: 'Projects',
  },
  {
    id: 3,
    name: 'My Contact',
    href: 'Contact',
  },
];
